<template>
    <main-layout id="list-outils" class="bg-gray-100 min-h-screen flex flex-col">

        <!-- En-tête + CTA sur fond dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="px-2 py-3">
                <app-header icon="tools" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Outillages</h1>
                    </div>
                </app-header>
                <!-- Action principale (garde id=main-action pour le JS) -->
                <action-bar :back="{ name: 'home' }" class="!p-0  mb-2">
                    <router-link
                        class="inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition"
                        id="main-action" to="new-outil">
                        <i class="inline-block h-6 w-6 mask mask-more bg-primary"></i>
                        <span><strong>Ajouter</strong></span>
                    </router-link>

                </action-bar>
                <!-- Barre de recherche / filtre -->
                <div>
                    <filter-bar @searchBarChanged="updateSearch" :gotFilter="true" filterText="Outillage actif"
                        @filterValChanged="changeList" placeholderFilter="Rechercher Nom, Marque, Modèle"
                        class="block pb-2">
                    </filter-bar>

                    <!-- Bouton Outillage actif / inactif -->
                    <button id="btnFilterActive" @click="toggleList"
                        class="px-4 py-2 rounded-lg text-md flex items-center justify-center gap-2 mb-5" :class="listVisible === 'active'
                            ? 'bg-vert text-white'
                            : 'bg-gray-300 text-gray-800'">
                        <i class="inline-block h-6 w-6 mask mask-tools"
                            :class="listVisible === 'active' ? 'bg-white' : 'bg-gray-800'"></i>
                        <span>
                            {{ listVisible === 'active' ? 'Outillage actif' : 'Outillage inactif' }}
                        </span>
                    </button>

                </div>
            </div>
        </div>

        <!-- Corps de page -->
        <div class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28">
            <div class="mx-auto w-full">

                <!-- Liste ACTIVE -->
                <div id="outils-items" class="list outils mx-auto w-full px-3 sm:px-4"
                    v-show="listVisible === 'active'">
                    <!-- WRAPPER carte avec coins arrondis + ombre + overflow-hidden -->
                    <div class="rounded-2xl shadow-[0_10px_30px_rgba(12,42,92,0.15)] overflow-hidden">
                        <outil-item v-for="outil in filterList" :key="outil.id" :outil="outil"
                            @listUpdated="handleNewList" class="group relative grid grid-cols-[1fr_auto] items-center
                        px-5 py-4 odd:bg-white even:bg-[#F7FAFD]
                        first:rounded-t-2xl last:rounded-b-2xl" />
                    </div>
                </div>

                <!-- Liste INACTIVE -->
                <div id="outils-items-inact" class="list outils mx-auto w-full px-3 sm:px-4"
                    v-show="listVisible === 'inactive'">
                    <div class="rounded-2xl shadow-[0_10px_30px_rgba(12,42,92,0.15)] overflow-hidden opacity-95">
                        <outil-item v-for="outil in filterListInact" :key="outil.id" :outil="outil"
                            @listUpdated="handleNewList" class="group relative grid grid-cols-[1fr_auto] items-center
                        px-5 py-4 odd:bg-white even:bg-[#F7FAFD]
                        first:rounded-t-2xl last:rounded-b-2xl" />
                    </div>
                </div>


            </div>
        </div>

    </main-layout>
</template>


<script>

import OutilItem from './OutilItem.vue'
import Outil from '../../js/models/Outil'

export default {

    data() {
        return {
            outils: [],
            strSearch: '',
            listVisible: 'active'
        }
    },

    computed: {

        filterList() {
            return this.outils.filter(outil => {
                let check = false;
                if (_.has(outil, 'type_outil') && outil.type_outil.nom.toLowerCase().includes(this.strSearch)) {
                    check = true
                }
                if (outil.marque.toLowerCase().includes(this.strSearch)) {
                    check = true
                }
                if (outil.modele.toLowerCase().includes(this.strSearch)) {
                    check = true
                }
                if (outil.actif === false) {
                    check = false
                }
                if (check) {
                    return outil
                }
            })
        },

        filterListInact() {
            return this.outils.filter(outil => {
                let check = false;
                if (_.has(outil, 'type_outil') && outil.type_outil.nom.toLowerCase().includes(this.strSearch)) {
                    check = true
                }
                if (outil.marque.toLowerCase().includes(this.strSearch)) {
                    check = true
                }
                if (outil.modele.toLowerCase().includes(this.strSearch)) {
                    check = true
                }
                if (outil.actif === true) {
                    check = false
                }
                if (check) {
                    return outil
                }
            })
        }

    },

    methods: {

        handleNewList() {
            this.fetchOutils()
        },

        fetchOutils() {
            let vueInstance = this;
            Outil.getList().then(res => vueInstance.outils = res)
        },

        updateSearch(str) {
            this.strSearch = String(str[0]).toLowerCase()
        },

        changeList(filter) {
            if (filter === false) {
                this.listVisible = 'inactive'
            } else {
                this.listVisible = 'active'
            }
        },
        // 👉 appelé par le bouton
        toggleList() {
            // si on est sur active → passe à inactive, sinon l’inverse
            const nextFilter = this.listVisible === 'active' ? false : true
            this.changeList(nextFilter)
        }

    },

    mounted() {

        this.fetchOutils();

        Outil
            .getDetecteurActif()
            .then(res => {
            })
            .catch(err => {
            })

    },

    components: {
        OutilItem
    }

}

</script>



// WEBPACK FOOTER //
// ListeOutils.vue?56360272